import {
    Dic
} from '@src/common/utils'
import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
const tableOption = function (videoShow) {
    if (videoShow) {
        return {
            stripe: true,
            page: true,
            rowKey: 'alarmTaskRuleCode',
            menuAlign: 'center',
            header: false,
            delBtn: false,
            editBtn: false,
            menu: false,
            index: true,
            indexLabel: '序号',
            emptyText: '暂无数据',
            column: [{
                label: '子系统',
                prop: 'subSystem',
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU004', value) : '';
                }
            },
            {
                label: '原始事件/告警',
                prop: 'originalName'
            },
            {
                label: '处理方式',
                prop: 'processType',
                slot: true
            },
            {
                label: '告警类型',
                prop: 'eventAlarmId',
                slot: true
            },
            {
                label: '告警级别',
                prop: 'alarmLevel',
                slot: true
            },
            {
                label: '任务自动派发工作组',
                prop: 'description',
                slot: true
            },
            {
                label: '任务自动派发',
                prop: 'autoAlarmTask',
                type: 'select',
                viewDisplay: true,
                viewFormatter: (row, value) => {
                    if (Number(value) === 1) {
                        return '启用'
                    } else {
                        return '禁用'
                    }
                },
                dicData: [{
                    label: '禁用',
                    value: '0'
                },
                {
                    label: '启用',
                    value: '1'
                }
                ],
                align: 'center'
            },
            ]
        }
    } else {
        return {
            add: '新增',
            edit: '修改',
            view: '查看',
            page: true,
            selection: false,
            index: true,
            rowKey: 'alarmTaskRuleCode',
            indexLabel: '序号',
            refreshBtn: false,
            columnBtn: false,
            stripe: true,
            addBtn: false,
            editBtn: false,
            delBtn: false,
            viewFormSlot: true,
            labelSuffix: '：',
            size: 'small',
            maxHeight: '100%',
            labelWidth: '140px',
            menuAlign: 'center',
            searchMenuSpan: 6,
            searchBtn: false,
            dialogHeight: 200,
            dialogWidth: '450px',
            emptyText: '暂无数据',
            menu: false,
            column: [{
                label: '子系统',
                prop: 'subSystem',
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU004', value) : '';
                }
            },
            {
                label: '原始事件/告警',
                prop: 'originalName'
            },
            {
                label: '两点报警',
                prop: 'multiAlarmType',
                span: 12,
                dicData: Dic.find('SENU100'),
                viewFormatter: (row, value) => {
                    if (value) {
                        return Dic.findByValue('SENU100', Number(value))
                    }
                    return ''
                },
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU100', value) : ''
                },
            },
            {
                label: '报警检测类型',
                prop: 'alarmDetectionType',
                span: 12,
                dicData: Dic.find('SENU101'),
                viewFormatter: (row, value) => {
                    if (value) {
                        return Dic.findByValue('SENU101', Number(value))
                    }
                    return ''
                },
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU101', value) : ''
                },
            },
            {
                label: '报警距离',
                prop: 'alarmDistanceType',
                span: 12,
                dicData: Dic.find('SENU102'),
                viewFormatter: (row, value) => {
                    if (value) {
                        return Dic.findByValue('SENU102', Number(value))
                    }
                    return ''
                },
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU102', value) : ''
                },
            },
            {
                label: '报警间隔',
                prop: 'alarmInterval',
            },
            {
                label: '处理方式',
                prop: 'processType',
                dicData: [{
                    label: '创建安全事件告警',
                    value: '1',
                },
                {
                    label: '创建设备故障告警',
                    value: '2',
                },
                {
                    label: '创建事件',
                    value: '3',
                },
                {
                    label: '忽略',
                    value: '4',
                },
                ],
                formatter: function (row, value) {
                    let str = ''
                    if (value == '1') {
                        str = '创建安全事件告警'
                    }
                    if (value == '2') {
                        str = '创建设备故障告警'
                    }
                    if (value == '3') {
                        str = '创建事件'
                    }
                    if (value == '4') {
                        str = '忽略'
                    }
                    return str
                },
            },
            {
                label: '告警类型',
                prop: 'eventAlarmName',
            },
            {
                label: '告警级别',
                prop: 'alarmLevel',
                dicData: [{
                    label: '紧急',
                    value: '1',
                },
                {
                    label: '严重',
                    value: '2',
                },
                {
                    label: '一般',
                    value: '3',
                },
                {
                    label: '普通',
                    value: '4',
                },
                ],
                formatter: function (row, value) {
                    let str = ''
                    if (value == '1') {
                        str = '紧急'
                    }
                    if (value == '2') {
                        str = '严重'
                    }
                    if (value == '3') {
                        str = '一般'
                    }
                    if (value == '4') {
                        str = '普通'
                    }
                    return str
                },
            },
            ]
        }
    }

}
export default tableOption